import { Button, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import ButtonLoading from '../../components/ButtonLoading';
import { JobT, LocationT } from '../../types/Job';
import Locations from '../jobs/NewJob/JobTab/Locations';
import { UserRegisterT } from './RegisterScreen';

export type IRegisterLocationsTabProps = {
    fields: UserRegisterT
    onChangeField(key: string, value: any): void
    job: JobT
    nextTab(): void
    updateJob(key: string, value: any): void
}

const RegisterLocationsTab: React.FC<IRegisterLocationsTabProps> = (props) => {
    const [validated, setValidated] = React.useState(false);

    const checkValidate = () => {
        setValidated(true)
        const loctions = _.isArray(props?.job?.locations) ? props?.job?.locations : []
        if (loctions.length <= 0) {
            throw new Error("Required fields are missing.")
        }
        loctions.map((item, index) => {
            if (!validateLocation(item)) {
                throw new Error("Required fields are missing.")
            }
        })
        return true
    }

    const validateLocation = (location: LocationT): boolean => {
        if (!location.address || location.address == "" || !location.locationType || location.locationType == "") {
            return false
        }
        return true
    }

    return (
        <div>
            <Locations
                // isReady={true}
                job={props.job}
                jobMode={null}

                // saveJob={null}
                updateJob={props.updateJob}
                required
                validated={validated}
            />

            <Button
                fullWidth
                // disabled={!checkValidate(props.fields)}
                color="success"
                variant="contained"
                onClick={() => {
                    // next(props.fields)
                }}
            >
                <Typography variant="button" color="#fff">Next</Typography>
            </Button>
        </div>
    );
}

export default RegisterLocationsTab